import { observer } from "mobx-react-lite";
import React from "react";
import { FormControl } from "react-bootstrap";
import { useFormContext } from "./Form";
import { emptyStringIfNull, withFormWrapper, } from "./withFormWrapper";
import { StaticInputValue } from "./StaticInput";
export var RawInput = observer(function (_a) {
    var name = _a.name, type = _a.type, disabled = _a.disabled, autoFocus = _a.autoFocus, onChange = _a.onChange, min = _a.min, max = _a.max, step = _a.step, maxLength = _a.maxLength, label = _a.label, staticFormatter = _a.staticFormatter, _b = _a.autoComplete, autoComplete = _b === void 0 ? "off" : _b, dataId = _a.dataId, dataLabel = _a.dataLabel, dataTestId = _a.dataTestId, ariaLabelledby = _a.ariaLabelledby, placeholder = _a.placeholder;
    var _c = useFormContext(), values = _c.values, formDisabled = _c.formDisabled, isStatic = _c.isStatic;
    var handleChange = React.useCallback(function (e) {
        if (onChange) {
            onChange(e.target.value, values.get(name));
        }
        values.set(name, e.target.value);
    }, [onChange, values, name]);
    if (isStatic) {
        return (React.createElement(StaticInputValue, { label: label, name: name, staticFormatter: staticFormatter, dataId: dataId, dataLabel: dataLabel, dataTestId: dataTestId }));
    }
    return (React.createElement(FormControl, { name: name, type: type, value: emptyStringIfNull(values.get(name)), disabled: disabled || formDisabled, autoFocus: autoFocus, onChange: handleChange, min: min, max: max, step: step, maxLength: maxLength, autoComplete: autoComplete, "aria-labelledby": ariaLabelledby, placeholder: placeholder }));
});
export var Input = withFormWrapper({ WrappedComponent: RawInput });
